import { useCartErrorState } from "context/CartErrorContext";
import logError from "utils/logError";

export default () => {
  let cartItemErrors = [];
  const { errors } = useCartErrorState();

  try {
    const invalidCartError =
      errors &&
      errors.length &&
      errors.find(
        (lsError: { metadata: { reason: string } }) =>
          lsError.metadata && lsError.metadata.reason === "not_reservable"
      );

    cartItemErrors =
      (invalidCartError &&
        invalidCartError.metadata &&
        invalidCartError.metadata.cartItems) ||
      [];
  } catch (err) {
    cartItemErrors = [];
    logError(
      typeof err === "string"
        ? err
        : "Error processing cart item errors in useCartItemErrors"
    );
  }
  return cartItemErrors;
};
